import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PageSource } from '../../model/enum/enums';

interface AdsState {
    pageSource: PageSource;
    showAds: boolean;
}

const initialState: AdsState = {
    pageSource: PageSource.Challenge,
    showAds: false
};

const adsSlice = createSlice({
    name: 'ads',
    initialState,
    reducers: {
        setPageSource: (state, action: PayloadAction<PageSource>) => {
            state.pageSource = action.payload;
        },
        setShowAds: (state, action: PayloadAction<boolean>) => {
            state.showAds = action.payload;
        }
    }
});

export const adsActions = adsSlice.actions;
export default adsSlice.reducer; 